// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_GENERAL_DC_REQUEST_DK = 'FETCH_GENERAL_DC_REQUEST_DK';
export const FETCH_GENERAL_DC_SUCCESS_DK = 'FETCH_GENERAL_DC_SUCCESS_DK';
export const FETCH_GENERAL_DC_FAILURE_DK = 'FETCH_GENERAL_DC_FAILURE_DK';

// CREATE PROPERTIES FOR TEAM MASTER
export const CREATE_GENERAL_DC_REQUEST_DK = 'CREATE_GENERAL_DC_REQUEST_DK';
export const CREATE_GENERAL_DC_SUCCESS_DK = 'CREATE_GENERAL_DC_SUCCESS_DK';
export const CREATE_GENERAL_DC_FAILURE_DK = 'CREATE_GENERAL_DC_FAILURE_DK';

//CREATE USER FORM
export const CREATE_USER_FORM_GENERAL_DC_DK = 'CREATE_USER_FORM_GENERAL_DC_DK';

// UPDATE PROPERTIES FOR TEAM MASTER
export const UPDATE_GENERAL_DC_REQUEST_DK = 'UPDATE_GENERAL_DC_REQUEST_DK';
export const UPDATE_GENERAL_DC_SUCCESS_DK = 'UPDATE_GENERAL_DC_SUCCESS_DK';
export const UPDATE_GENERAL_DC_FAILURE_DK = 'UPDATE_GENERAL_DC_FAILURE_DK';

// FETCH SINGLE TEAM
export const FETCH_SINGLE_GENERAL_DC_REQUEST_DK = 'FETCH_SINGLE_GENERAL_DC_REQUEST_DK';
export const FETCH_SINGLE_GENERAL_DC_SUCCESS_DK = 'FETCH_SINGLE_GENERAL_DC_SUCCESS_DK';
export const FETCH_SINGLE_GENERAL_DC_FAILURE_DK = 'FETCH_SINGLE_GENERAL_DC_FAILURE_DK';

// DELETE PROPERTIES FOR TEAM MASTER
export const DELETE_GENERAL_DC_REQUEST_DK = 'DELETE_GENERAL_DC_REQUEST_DK';
export const DELETE_GENERAL_DC_SUCCESS_DK = 'DELETE_GENERAL_DC_SUCCESS_DK';
export const DELETE_GENERAL_DC_FAILURE_DK = 'DELETE_GENERAL_DC_FAILURE_DK';

// USERFORM RESET

export const GENERAL_DC_USERFORM_RESET_DK = 'GENERAL_DC_USERFORM_RESET_DK';

// navigate to unit component
export const NAVIGATE_GENERAL_DC_DETAILS_DK = 'NAVIGATE_GENERAL_DC_DETAILS_DK';
// navigate to company component
export const NAVIGATE_GENERAL_DC_DK = 'NAVIGATE_GENERAL_DC_DK';
export const GENERAL_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK = 'GENERAL_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK';
export const GENERAL_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK = 'GENERAL_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK';


// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_GENERAL_DC_INVOICE_REQUEST = 'FETCH_GENERAL_DC_INVOICE_REQUEST';
export const FETCH_GENERAL_DC_INVOICE_SUCCESS = 'FETCH_GENERAL_DC_INVOICE_SUCCESS';
export const FETCH_GENERAL_DC_INVOICE_FAILURE = 'FETCH_GENERAL_DC_INVOICE_FAILURE';

export const RESET_GENERAL_DC_INVOICE = 'RESET_GENERAL_DC_INVOICE';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_GENERAL_DC_STYLE_REQUEST_DK = 'FETCH_GENERAL_DC_STYLE_REQUEST_DK';
export const FETCH_GENERAL_DC_STYLE_SUCCESS_DK = 'FETCH_GENERAL_DC_STYLE_SUCCESS_DK';
export const FETCH_GENERAL_DC_STYLE_FAILURE_DK = 'FETCH_GENERAL_DC_STYLE_FAILURE_DK';